import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5162ee32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-goods" }
const _hoisted_2 = {
  key: 0,
  class: "active-tag"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "outer-sphere" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "goods-spec-num" }
const _hoisted_8 = { class: "goods-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "goods-image",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goodsDetails($props.good_item.goods_id)))
    }, [
      ($props.good_item.icon_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.webpFilters($props.good_item.icon_url),
              alt: ""
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: _ctx.webpFilters($props.good_item.goods_image_url) || _ctx.webpFilters($props.good_item.image)
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", {
        class: "goods-name",
        innerHTML: $props.good_item.goods_name,
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goodsDetails($props.good_item.goods_id)))
      }, null, 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, _toDisplayString($props.good_item.goods_spec) + " *" + _toDisplayString($props.good_item.goods_num), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($props.good_item.goods_price).thousands()), 1)
    ])
  ]))
}